import React from 'react';
import { FaLanguage } from "react-icons/fa";
import { MdLanguage } from "react-icons/md";
const Languages = () => {
    return (
        <>
            <div className='flex items-center text-xl font-bold'>
                <FaLanguage className='w-6 h-6 mr-2 mb-2' /> Languages
            </div>
            <div className='ml-8'>
                <div className="flex items-center mb-2">

                    <MdLanguage className='w-4 h-4 mr-2' /> Bengali: Native
                </div>
                <div className="flex items-center mb-2">

                    <MdLanguage className='w-4 h-4 mr-2' /> English: Professional Working Proficiency
                </div>
            </div>
        </>
    );
};

export default Languages;
